/**
 * 碰撞救援线索列表
 */
import { COLLISIONLIST } from '../types';

export default {
    name: `${COLLISIONLIST}`,
    path: '/collisionList',
    component: () => import(/* webpackChunkName: 'collisionList' */ '@/views/collisionList/'),
    redirect: { name: `${COLLISIONLIST}Index` },
    meta: {
        title: '碰撞救援',
        savedPosition: { x: 0, y: 0 },
    },
    children: [
        {
            name: `${COLLISIONLIST}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'collisionList' */ '@/views/collisionList/home/Home.vue'),
        },
        {
            name: `${COLLISIONLIST}Detail`,
            path: 'detail/:id',
            component: () => import(/* webpackChunkName: 'collisionList' */ '@/views/collisionList/detail/Detail.vue'),
        },
    ],
};
